<ng-container *ngIf="values; else noValues">
    <ng-container [ngSwitch]="values.length">
      <ng-container *ngSwitchCase="0" >
        <mat-label translate>{{title_none}}</mat-label>
      </ng-container> 
      <ng-container *ngSwitchCase="1" >
        <mat-form-field class="def-select single-element-select" appearance="outline" floatLabel="always" [ngStyle]="{'width' : adaptive ? '100%' : 'auto' }" >
          <mat-label translate>{{title_single}}</mat-label>
          <mat-select   (selectionChange)    =   "onChange($event)" 
                        [(ngModel)]="currentValue" disabled>
            <mat-option [value]="value" 
                        *ngFor="let value of values">
                        <span *ngIf="value.translate_param; else noTranslate"> {{ value.name | translate: value.translate_param }} </span>
                        <ng-template #noTranslate>
                          <span> {{ value.name | translate }} </span>
                        </ng-template>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
      <ng-container *ngSwitchDefault  >
        <mat-form-field class="def-select" appearance="outline" floatLabel="always" [ngStyle]="{'width' : adaptive ? '100%' : 'auto' }">
          <mat-label translate> {{title_multiple}} </mat-label>
          <mat-select   (selectionChange)    =   "onChange($event)" 
                        [(ngModel)] = "currentValue"
                        [multiple]  = "multiple"
                        [disabled]  = "isDisabled()">

            <select-all-option  *ngIf   = "multiple"
                                [value] = "currentValue" 
                                [values]= "values"
                                (setter)= "allSetter($event)">
            </select-all-option>
            
            <mat-option [value]="value" 
                        *ngFor="let value of values"
                        [disabled]="disableOption(value)">
              <span *ngIf="value.translate_param; else noTranslate"> {{ value.name | translate: value.translate_param }} </span>
              <ng-template #noTranslate>
                 <span> {{ value.name | translate }} </span>
              </ng-template>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
    </ng-container>
</ng-container>
  
<ng-template #noValues>
<!-- handle no data loaded due to error -->
</ng-template>
